import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {State, StateService} from "@alpha/services";
import {Observable} from "rxjs";

@Component({
  selector: 'recent-lookups',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './recent-lookups.component.html',
  styleUrls: ['./recent-lookups.component.scss']
})
export class RecentLookupsComponent {
  lookups: string[] = []

  constructor(private state:StateService) {
    this.state.stateBS.subscribe((state)=>{
      this.lookups = state.recent_lookups;
    })
  }

  click(lookup:string){
    this.state.lookupBS.next(lookup);
  }
}
